import { useMemo } from "react";
import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";

const EditorViewer = ({ delta, className = "" }) => {
  const contents = useMemo(() => {
    const converter = new QuillDeltaToHtmlConverter(delta.ops);
    return converter.convert();
  }, [delta]);

  const containerClassName = useMemo(
    () => ["ql-container", "ql-bubble", className].join(" ").trim(),
    [className]
  );

  return (
    <div className={containerClassName}>
      <div
        className="ql-editor"
        dangerouslySetInnerHTML={{
          __html: contents,
        }}
      />
    </div>
  );
};

export default EditorViewer;
